<template>
  <div
    class="country-dropdown"
    v-show="query"
    :style="{ top: offsetTop + 'px' }"
  >
    <div class="country-item no-country" v-if="!filterCountries.length">
      没找到任何国家
    </div>

    <div
      class="country-item"
      v-for="country in filterCountries"
      :key="country.code"
      @click="countrySelect(country)"
    >
      {{ country.name }}
    </div>
  </div>
</template>

<script>
module.exports = {};
</script>

<style lang="less">
.country-dropdown {
  position: absolute;
  z-index: 50;
  left: 0em;
  margin-left: 0.11rem;
  right: 0.11rem;
  border: 1px solid #f0f0f0;
  overflow-y: scroll;
  border-radius: 2px;
}

.country-item {
  padding: 0 0.1rem;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fbfbfb;
  box-sizing: border-box;
  font-size: 0.15rem;
  height: 0.36rem;
  line-height: 0.36rem;
  position: relative;
  color: #6f6f6f;

  &:active {
    background-color: #e9ecf2;
  }

  & + .country-item::before {
    content: '';
    display: block;
    border-top: 1px solid #f0f0f0;
    position: absolute;
    top: 0;
    left: 0.1rem;
    right: 0;
  }

  &.no-country {
    color: #aaa;
  }

  &.no-country:active {
    background-color: #fbfbfb;
  }
}
</style>
